import { BaseDto } from './base-dto';

export class mediaCitasano extends BaseDto {
    public media !: number;
    public ano!:number;

 } 
